module.exports = __webpack_public_path__ + "static/media/organizationBG.954153a9.png";